import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { isImpactCategoryId } from '@upright/common/model/input/impacts/types';
import { Valence } from '@upright/common/model/types';
import { intersection, keys } from 'lodash';
import { getPaisForImpactCategory } from '../common/pai-mapping';
import { PaiLensData } from '../types';

export const paiLensDefaultImpactSelectionState = 'default' as const;
const paiLensDefaultSelectionState = {
  impact: paiLensDefaultImpactSelectionState,
} as const;

export interface PaiLensSelectionState {
  impact: ImpactCategoryId | typeof paiLensDefaultImpactSelectionState;
}

function serializeSelectionState(state: PaiLensSelectionState) {
  if (state.impact === paiLensDefaultImpactSelectionState) {
    return undefined; // Default is stored as no url parameter
  }
  return state.impact;
}

function unserializeSelectionState(value: string | undefined) {
  if (!value || !isImpactCategoryId(value)) {
    return paiLensDefaultSelectionState;
  }
  return { impact: value };
}

function isImpactDataAreaClickable(data: PaiLensData, impactId: ImpactCategoryId, _valence: Valence) {
  const pais = data.pais;
  if (!pais) {
    return false;
  }
  const paiTypesForImpact = getPaisForImpactCategory(impactId).map(metric => metric.toString());
  const dataKeys = keys(pais);
  return intersection(paiTypesForImpact, dataKeys).length > 0;
}

function onPaiBoxClick(currentState: PaiLensSelectionState, impact: ImpactCategoryId) {
  if (currentState.impact === impact) {
    return { ...currentState, impact: paiLensDefaultImpactSelectionState };
  } else {
    return { ...currentState, impact };
  }
}

function showClearSelectionButton(state: PaiLensSelectionState) {
  return state.impact !== paiLensDefaultImpactSelectionState;
}
function getClearedSelectionState(_state: PaiLensSelectionState) {
  return paiLensDefaultSelectionState;
}

export const paiLensSelectionState = {
  serializeSelectionState,
  // TODO should this be removed?
  unserializeSelectionState,
  isImpactDataAreaClickable,
  onImpactDataAreaClick: onPaiBoxClick,
  showClearSelectionButton,
  getClearedSelectionState,
};
